//# sourceMappingURL=page.mjs.map
/// <reference types="./page.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class PagePayload extends $CustomType {
  constructor(page_size, page_index) {
    super();
    this.page_size = page_size;
    this.page_index = page_index;
  }
}
export const PagePayload$PagePayload = (page_size, page_index) =>
  new PagePayload(page_size, page_index);
export const PagePayload$isPagePayload = (value) =>
  value instanceof PagePayload;
export const PagePayload$PagePayload$page_size = (value) => value.page_size;
export const PagePayload$PagePayload$0 = (value) => value.page_size;
export const PagePayload$PagePayload$page_index = (value) => value.page_index;
export const PagePayload$PagePayload$1 = (value) => value.page_index;

export class Pagination extends $CustomType {
  constructor(total, page_size, page_index, page_count, elements) {
    super();
    this.total = total;
    this.page_size = page_size;
    this.page_index = page_index;
    this.page_count = page_count;
    this.elements = elements;
  }
}
export const Pagination$Pagination = (total, page_size, page_index, page_count, elements) =>
  new Pagination(total, page_size, page_index, page_count, elements);
export const Pagination$isPagination = (value) => value instanceof Pagination;
export const Pagination$Pagination$total = (value) => value.total;
export const Pagination$Pagination$0 = (value) => value.total;
export const Pagination$Pagination$page_size = (value) => value.page_size;
export const Pagination$Pagination$1 = (value) => value.page_size;
export const Pagination$Pagination$page_index = (value) => value.page_index;
export const Pagination$Pagination$2 = (value) => value.page_index;
export const Pagination$Pagination$page_count = (value) => value.page_count;
export const Pagination$Pagination$3 = (value) => value.page_count;
export const Pagination$Pagination$elements = (value) => value.elements;
export const Pagination$Pagination$4 = (value) => value.elements;

export class Equal extends $CustomType {}
export const FilterOperator$Equal = () => new Equal();
export const FilterOperator$isEqual = (value) => value instanceof Equal;

export class NotEqual extends $CustomType {}
export const FilterOperator$NotEqual = () => new NotEqual();
export const FilterOperator$isNotEqual = (value) => value instanceof NotEqual;

export class Contains extends $CustomType {}
export const FilterOperator$Contains = () => new Contains();
export const FilterOperator$isContains = (value) => value instanceof Contains;

export class MetadataFilter extends $CustomType {
  constructor(key, value, op) {
    super();
    this.key = key;
    this.value = value;
    this.op = op;
  }
}
export const MetadataFilter$MetadataFilter = (key, value, op) =>
  new MetadataFilter(key, value, op);
export const MetadataFilter$isMetadataFilter = (value) =>
  value instanceof MetadataFilter;
export const MetadataFilter$MetadataFilter$key = (value) => value.key;
export const MetadataFilter$MetadataFilter$0 = (value) => value.key;
export const MetadataFilter$MetadataFilter$value = (value) => value.value;
export const MetadataFilter$MetadataFilter$1 = (value) => value.value;
export const MetadataFilter$MetadataFilter$op = (value) => value.op;
export const MetadataFilter$MetadataFilter$2 = (value) => value.op;

export const default_page_size = 20;

export const max_page_size = 50;

export const default_page = /* @__PURE__ */ new PagePayload(
  default_page_size,
  0,
);

export const max_page = /* @__PURE__ */ new PagePayload(default_page_size, 0);

export const empty_page = /* @__PURE__ */ new Pagination(
  0,
  0,
  0,
  0,
  /* @__PURE__ */ toList([]),
);

export function start() {
  return new PagePayload(default_page_size, 0);
}

export function page_payload(page_index) {
  return new PagePayload(default_page_size, page_index);
}

export function page_decoder(element_decoder) {
  return $decode.field(
    "total",
    $decode.int,
    (total) => {
      return $decode.field(
        "page_size",
        $decode.int,
        (page_size) => {
          return $decode.field(
            "page_index",
            $decode.int,
            (page_index) => {
              return $decode.field(
                "page_count",
                $decode.int,
                (page_count) => {
                  return $decode.field(
                    "elements",
                    element_decoder,
                    (elements) => {
                      return $decode.success(
                        new Pagination(
                          total,
                          page_size,
                          page_index,
                          page_count,
                          elements,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function page_encoder(page, element_encoder) {
  return $json.object(
    toList([
      ["total", $json.int(page.total)],
      ["page_size", $json.int(page.page_size)],
      ["page_index", $json.int(page.page_index)],
      ["page_count", $json.int(page.page_count)],
      ["elements", $json.array(page.elements, element_encoder)],
    ]),
  );
}

export function filter_operator_to_string(op) {
  if (op instanceof Equal) {
    return "eq";
  } else if (op instanceof NotEqual) {
    return "neq";
  } else {
    return "contains";
  }
}

export function string_to_filter_operator(filter_string) {
  if (filter_string === "eq") {
    return new Ok(new Equal());
  } else if (filter_string === "neq") {
    return new Ok(new NotEqual());
  } else if (filter_string === "contains") {
    return new Ok(new Contains());
  } else {
    return new Error(undefined);
  }
}

export function friendly_operator_display(op) {
  if (op instanceof Equal) {
    return "=";
  } else if (op instanceof NotEqual) {
    return "≠";
  } else {
    return "contains";
  }
}

export function compute_page_count(element_count, page_size) {
  let _block;
  let _pipe = element_count;
  let _pipe$1 = $int.divide(_pipe, page_size);
  _block = $result.unwrap(_pipe$1, 0);
  let full_pages = _block;
  let $ = (() => {
    let _pipe$2 = element_count;
    let _pipe$3 = $int.modulo(_pipe$2, page_size);
    return $result.unwrap(_pipe$3, 0);
  })();
  if ($ === 0) {
    return full_pages;
  } else {
    return full_pages + 1;
  }
}

export function reset_page(page) {
  return new PagePayload(page.page_size, 0);
}

export function next(page) {
  let page_index = page.page_index + 1;
  return new PagePayload(page.page_size, page_index);
}
